import { render } from "./StatusAttached.vue?vue&type=template&id=e70615c6"
import script from "./StatusAttached.vue?vue&type=script&lang=js"
export * from "./StatusAttached.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__